import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import "./SubHeader.scss";
import { UserContext } from "../../routes/routes";
import {
  users,
  userDepartment,
  userClassification,
  userDesignation,
  locationMaster,
  organizations,
  tempelateMaster,
  assessmentTypes,
  questionCategory,
  surveyForms,
  surveyQuiz,
  surveyPoll,
  surveyAssignment,
  surveyAssignmentListQuizForm,
  surveyAssignmentListPoll,
  responseAnalysisReport,
  SentimentAnalyticsReport,
  SurveyAssignedUsersResponses,
  FormReport,
  QuestionBankAnalysisReport,
  comparisonReport,
  crossTabReport,
  trendReport,
} from "../../utils/ApiUrl";
import { RoleTypeCode } from "../../utils/Constant";
import Tour from "../.././tour/Tour";
import ESInput from "../../controls/ESInput";
import ESTooltip from "../../controls/ESTooltip";
import infoico from "../../assets/images/68.png";
import { tourStepsConfigAdmin } from "../../tour/tourStepsConfigAdmin";



interface SubHeaderProps {
  data?: any;
  isAddIconVisible?:boolean;
}
function SubHeader({ data,isAddIconVisible }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { appContextdata } = useContext<any>(UserContext);
  const [role, setRole] = useState("");
  const [isNavTourActive, setIsNavTourActive] = useState(false);

  const fetchRole = () => {
    if (appContextdata?.Role === RoleTypeCode?.SuperAdmin) {
      setRole("SuperAdmin");
    } else if (appContextdata?.Role === RoleTypeCode?.Administrator) {
      setRole("Admin");
    } else if (appContextdata?.Role === RoleTypeCode?.User) {
      setRole("User");
    } else if (appContextdata?.Role === RoleTypeCode?.Coordinator) {
      setRole("Coordinator");
    } else if (appContextdata?.Role === RoleTypeCode?.Responder) {
      setRole("Responder");
    }
  };

  useEffect(() => {
    if (appContextdata?.IsSystemGeneratedPassword === "true") {
      navigate("/changePassword");
    }
  }, [appContextdata?.IsSystemGeneratedPassword]);

  useEffect(() => {
    if (appContextdata?.Role) {
      fetchRole();
    }
  }, [appContextdata?.Role]);

  const isActive = (route: string) => location.pathname === route;

  const isDropdownActive = () =>
    isActive(users) ||
    isActive(userDepartment) ||
    isActive(userClassification) ||
    isActive(userDesignation) ||
    isActive(locationMaster);

  const getLinkClassName = (route: string) =>
    isActive(route) ? "nav-dropdown-item active" : "nav-dropdown-item";

  const getDropdownClassName = () =>
    isDropdownActive() ? "nav-dropdown active" : "nav-dropdown";

  return (
    <div className="nav sticky-top">
      {role && (
        <Navbar expand="lg" className="subnavbar">
          <Container fluid>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="me-auto" navbarScroll>
                <div
                  className={`nav-item d-flex align-items-center ${
                    isActive("/dashboard") ? "active" : ""
                  }`}
                >
                  {/* <span className="menu-icon dashboardico"></span> */}
                  <Nav.Link
                    as={Link}
                    to="/dashboard"
                    className={
                      location.pathname === "/dashboard" ? "active" : ""
                    }
                    data-tour="dashboard"
                  >
                    Dashboard
                  </Nav.Link>
                </div>

                {(role === "SuperAdmin" || role === "Admin") && (
                  <div className="nav-item d-flex align-items-center">
                    {/* <span className="menu-icon usersico"></span> */}
                    <NavDropdown
                      title="User Management"
                      id="navbarScrollingDropdown"
                      align="end"
                      className={getDropdownClassName()}
                      data-tour="user-management"
                    >
                      <NavDropdown.Item
                        as={Link}
                        to="/users"
                        className={getLinkClassName(users)}
                        //data-tour="user-management"
                      >
                        Users
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={userDepartment}
                        className={getLinkClassName(userDepartment)}
                      >
                        Department
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={userClassification}
                        className={getLinkClassName(userClassification)}
                      >
                        Classification
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={userDesignation}
                        className={getLinkClassName(userDesignation)}
                      >
                        Designation
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={locationMaster}
                        className={getLinkClassName(locationMaster)}
                      >
                        Location
                      </NavDropdown.Item>
                    </NavDropdown>
                  </div>
                )}

                {(role === "SuperAdmin" || role === "Admin") && (
                  <div className="nav-item d-flex align-items-center">
                    {/* <span className="menu-icon mastersico"></span> */}
                    <NavDropdown
                      title="Masters"
                      id="navbarScrollingDropdown"
                      align="end"
                      className={
                        isActive(organizations) ||
                        isActive(tempelateMaster) ||
                        isActive(assessmentTypes) ||
                        isActive(questionCategory)
                          ? "nav-dropdown active"
                          : "nav-dropdown"
                      }
                      data-tour="master"
                    >
                      <NavDropdown.Item
                        as={Link}
                        to={organizations}
                        className={getLinkClassName(organizations)}
                      >
                        Organizations
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={tempelateMaster}
                        className={getLinkClassName(tempelateMaster)}
                      >
                        Email Template
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={assessmentTypes}
                        className={getLinkClassName(assessmentTypes)}
                      >
                        Assessment Types
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to={questionCategory}
                        className={getLinkClassName(questionCategory)}
                      >
                        Question Category
                      </NavDropdown.Item>
                    </NavDropdown>
                  </div>
                )}

                {(role === "SuperAdmin" || role === "Admin") && (
                  <>
                    <div
                      className={`nav-item d-flex align-items-center ${
                        isActive("/questions") ? "active" : ""
                      }`}
                    >
                      {/* <span className="menu-icon questioncollectionico"></span> */}
                      <Nav.Link
                        as={Link}
                        to="/questions"
                        className={
                          location.pathname === "/questions" ? "active" : ""
                        }
                        data-tour="question-bank"
                      >
                        Question Bank
                      </Nav.Link>
                    </div>

                    <div className="nav-item d-flex align-items-center">
                      {/* <span className="menu-icon menu-icon surveysico"></span> */}
                      <NavDropdown
                        title="Forms"
                        id="navbarScrollingDropdown"
                        align="end"
                        className={
                          isActive(surveyForms) ||
                          isActive(surveyQuiz) ||
                          isActive(surveyPoll)
                            ? "nav-dropdown active"
                            : "nav-dropdown"
                        }
                        data-tour="survey-forms"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to={surveyForms}
                          className={getLinkClassName(surveyForms)}
                        >
                          Forms
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={surveyQuiz}
                          className={getLinkClassName(surveyQuiz)}
                        >
                          Quiz
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={surveyPoll}
                          className={getLinkClassName(surveyPoll)}
                        >
                          Poll
                        </NavDropdown.Item>
                      </NavDropdown>
                    </div>

                    <div className="nav-item d-flex align-items-center">
                      {/* <span className="menu-icon menu-icon surveysico"></span> */}
                      <NavDropdown
                        title="Assignment"
                        id="navbarScrollingDropdown"
                        align="end"
                        className={
                          isActive(surveyAssignmentListQuizForm) ||
                          isActive(surveyAssignmentListPoll)
                            ? "nav-dropdown active"
                            : "nav-dropdown"
                        }
                        data-tour="survey-assignments"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to={surveyAssignmentListQuizForm}
                          className={getLinkClassName(surveyForms)}
                        >
                          Form/Quiz
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={surveyAssignmentListPoll}
                          className={getLinkClassName(surveyQuiz)}
                        >
                          Poll
                        </NavDropdown.Item>
                      </NavDropdown>
                    </div>

                    <div className="nav-item d-flex align-items-center">
                      {/* <span className="menu-icon mastersico"></span> */}
                      <NavDropdown
                        title="Reports"
                        id="navbarScrollingDropdown"
                        align="end"
                        className={
                          isActive(responseAnalysisReport) ||
                          isActive(SentimentAnalyticsReport) ||
                          isActive(SurveyAssignedUsersResponses) ||
                          isActive(FormReport) ||
                          isActive(comparisonReport) ||
                          isActive(trendReport) ||
                          isActive(crossTabReport) ||
                          isActive(QuestionBankAnalysisReport)
                            ? "nav-dropdown active"
                            : "nav-dropdown"
                        }
                        data-tour="reports"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to={responseAnalysisReport}
                          className={getLinkClassName(responseAnalysisReport)}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Response Analysis Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={SentimentAnalyticsReport}
                          className={getLinkClassName(
                            "/SentimentAnalyticsReport"
                          )}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Sentiment Analytics Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={SurveyAssignedUsersResponses}
                          className={getLinkClassName(
                            "/SurveyAssignedUsersResponses"
                          )}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Markable Response Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={comparisonReport}
                          className={getLinkClassName(comparisonReport)}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Comparison Report
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          as={Link}
                          to={crossTabReport}
                          className={getLinkClassName(crossTabReport)}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          CrossTab Report
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          as={Link}
                          to={trendReport}
                          className={getLinkClassName(trendReport)}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Trend Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={FormReport}
                          className={getLinkClassName("/form-report")}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Form Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to={QuestionBankAnalysisReport}
                          className={getLinkClassName(
                            "/QuestionBankAnalysisReport"
                          )}
                          disabled={!appContextdata?.IsSubscriptionActive}
                        >
                          Question Bank Analysis Report
                        </NavDropdown.Item>
                      </NavDropdown>
                    </div>

                    <div
                      className={`nav-item d-flex align-items-center ${
                        isActive("/settings") ? "active" : ""
                      }`}
                    >
                      <Nav.Link
                        as={Link}
                        to="/settings"
                        className={
                          location.pathname === "/settings" ? "active" : ""
                        }
                        data-tour="settings"
                      >
                        Settings
                      </Nav.Link>
                    </div>

                    {role === "Admin" && (
                      <div
                        className={`nav-item d-flex align-items-center ${
                          isActive("/template-user") ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          as={Link}
                          to="/template-user"
                          className={
                            location.pathname === "/template-user"
                              ? "active"
                              : ""
                          }
                          data-tour="template"
                        >
                          Template
                        </Nav.Link>
                      </div>
                    )}
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
          <ESTooltip text="User Guide" placement="top">
            <button
              //variant="outline-info"
              //size="sm"
              onClick={() => setIsNavTourActive(true)}
              style={{
                outline: "none",
                boxShadow: "none",
                border: "none",
                background: "none",
              }}
            >
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30.715" viewBox="0 0 30 42.715">
                    <g id="Layer_2" data-name="Layer 2" transform="translate(-0.995 3.952)">
                      <path id="Path_9727" data-name="Path 9727" d="M29.547,29.528h0a1.364,1.364,0,0,1,0-1.745A12.177,12.177,0,0,0,32.274,20.4,12.423,12.423,0,0,0,20.315,7.71a12.273,12.273,0,0,0-9.859,20.059,1.364,1.364,0,0,1,0,1.759h0a1.364,1.364,0,0,1-2.086,0,15,15,0,1,1,23.25,0,1.364,1.364,0,0,1-2.073,0Z" transform="translate(-4 -9)" />
                      <path id="Path_9730" data-name="Path 9730" d="M13,2a3.016,3.016,0,0,0-3,3V16.813l-.656-.687-.25-.219a2.961,2.961,0,0,0-4.187,4.188v.031l8.188,8.094.063.031.031.063a8.307,8.307,0,0,0,5,1.688h1.719a8.171,8.171,0,0,0,8.188-8.187V14a3.016,3.016,0,0,0-3-3,2.9,2.9,0,0,0-1.187.281A3.021,3.021,0,0,0,21,9a2.984,2.984,0,0,0-2,.781A2.984,2.984,0,0,0,17,9a2.95,2.95,0,0,0-1,.188V5A3.016,3.016,0,0,0,13,2Zm0,2a1,1,0,0,1,1,1V16h2V12a1,1,0,0,1,2,0v4h2V12a1,1,0,0,1,2,0v4h2.094V14a1,1,0,0,1,2,0v7.813A6.128,6.128,0,0,1,19.906,28H18.188a6.221,6.221,0,0,1-3.781-1.312l-8.094-8a.875.875,0,0,1,0-1.375.875.875,0,0,1,1.375,0L12,21.625V5A1,1,0,0,1,13,4Z" transform="translate(-2.075 8.763)" />
                      <path id="Path_9729" data-name="Path 9729" d="M119.25,100.833,112,96v9.667Z" transform="translate(-98.757 -89.717)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" />
                    </g>
                  </svg> */}
              <img src={infoico} alt="image" width={"30px"} />
            </button>
          </ESTooltip>
        </Navbar>
      )}

      <Tour
        isActive={isNavTourActive}
        onClose={() => setIsNavTourActive(false)}
        data={data}
        isAddIconVisible={isAddIconVisible}
      />
    </div>
  );
}

export default SubHeader;
